import React, { useState } from 'react';
import { Share2, Twitter, Facebook, Linkedin, Link, Check } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

export default function SocialShare({ artistId, artistName }) {
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);

  const baseUrl = window.location.origin;
  const shareUrl = `${baseUrl}/artist/${artistId}`;
  const shareText = `Check out ${artistName || 'this artist'} on RazientSounds!`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success('Link copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy link');
    }
  };

  const shareLinks = [
    {
      name: 'Twitter',
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
      color: 'hover:bg-blue-500/20 hover:text-blue-400'
    },
    {
      name: 'Facebook',
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      color: 'hover:bg-blue-600/20 hover:text-blue-500'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      color: 'hover:bg-blue-700/20 hover:text-blue-600'
    }
  ];

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setShowMenu(!showMenu)}
        className="hover:bg-white/10"
      >
        <Share2 size={18} className="mr-2" />
        Share
      </Button>

      {showMenu && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40"
            onClick={() => setShowMenu(false)}
          />
          
          {/* Menu */}
          <div className="absolute right-0 top-full mt-2 w-48 glass-heavy rounded-xl border border-white/10 py-2 z-50">
            {shareLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`flex items-center gap-3 px-4 py-2 text-sm text-white/80 transition-colors ${link.color}`}
                onClick={() => setShowMenu(false)}
              >
                <link.icon size={18} />
                {link.name}
              </a>
            ))}
            
            <div className="border-t border-white/10 my-2" />
            
            <button
              onClick={handleCopyLink}
              className="flex items-center gap-3 px-4 py-2 text-sm text-white/80 w-full hover:bg-white/10 transition-colors"
            >
              {copied ? <Check size={18} className="text-green-400" /> : <Link size={18} />}
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
